<div class="course-group-list-empty-content">
  <icon set="uil" name="sad" class="course-group-list-empty-content-icon" />

  <p class="course-group-list-label">
    {{ "COURSES.COURSE.NO_GROUPS_IN_COURSE" | translate }}
  </p>
</div>
